module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAAXNSR0IArs4c6QAAAOBJREFUKBVjnD17dvi/f//6GRgYJIEYBN4zMjIu////vx6QbQMSAPJ/AKn1QLF4FqDi6UDOFyA+BMQgyT9Q+iVQAVgMyOcAsiOB9HoWICHIxMSUmZqauhKkEBeYOXPmR6A6QSZcCrCI/weJkaIBbMaoBixBiSFESigxgnSDYpoBmDzagDGZBGLjABxAcT6QHEjDdyBWgmJQWvrMzMys8efPnzagWDwQwwEwPX0HOakHqAgc7SAZoCAvVLETXCWEcQ2YlraC3TV37lwpoLNgyRtNHQMD0MbvioqKtxwdHf8AABbLR/fqJbHLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/phone.png
// module id = 443
// module chunks = 0